import React from 'react';
import CompanyTerminationConsult from './Company';

const TerminationConsult: React.FC = () => {
  return <CompanyTerminationConsult />;
};

export default TerminationConsult;
